// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a2201178","769":"7f15e30f"}[chunkId] + ".chunk.js";
};